<template>
	<div class="order-search-body">
		<div class="percent-search">
			<div class="filters-box-row" :style="collapse ? 'height: 50px' : ''">
				<div class="filters-container">
					<div class="input-box">
						<span>启用状态：</span>
						<el-select v-model="disabledflag" class="filter-input" size='small'>
							<el-option :value="-1" label="全部"></el-option>
							<el-option :value="0" label="启用"></el-option>
							<el-option :value="1" label="停用"></el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>员工名称：</span>
						<el-select
							size="small"
							class="filter-input"
							v-model="staff"
							filterable
							multiple
							collapse-tags
							placeholder="请选择员工">
							<el-option
								v-for="item in options"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>客户名称：</span>
						<el-select
							size="small"
							class="filter-input"
							v-model="customer"
							filterable
							multiple
							collapse-tags
							placeholder="请选择客户">
							<el-option
								v-for="item in customerOptions"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>店铺级大类：</span>
						<el-select v-model="shopCategoryBigId" class="filter-input" size='small' @change="bcChange">
							<el-option value="0" label="全部"></el-option>
							<template v-for="(item) in bc">
								<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
							</template>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box" v-if="bigcategoryview === 1">
						<span>店铺级小类：</span>
						<el-select v-model="shopCategorySmallId" class="filter-input" size='small'>
							<el-option value="0" label="全部"></el-option>
							<template v-for="(item) in sc">
								<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
							</template>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>商品信息：</span>
						<el-input
							class="filter-input"
							v-model="product"
							placeholder="请输入商品名称/编号"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>规格信息：</span>
						<el-input
							class="filter-input"
							v-model="spec"
							placeholder="请输入规格名称/编号"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>方案类型：</span>
						<el-select v-model="plantype" class="filter-input" size='small'>
							<el-option :value="-1" label="全部"></el-option>
							<el-option :value="0" label="提成"></el-option>
							<el-option :value="1" label="返佣"></el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>方案方式：</span>
						<el-select v-model="planway" class="filter-input" size='small'>
							<el-option :value="-1" label="全部"></el-option>
							<el-option :value="0" label="按商品"></el-option>
							<el-option :value="1" label="按订单"></el-option>
						</el-select>
					</div>
				</div>
			</div>
			<div class="percent-search-btn">
				<el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
				</el-button>
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="filters-box-row filters-box-row3" v-if="AuthorityList['11_0001_0002_00']">
			<el-button size="small" type="primary" class="btn fx-btn" style="margin-left: 0px" @click="goDetail">新建方案</el-button>
			<el-button size="small" type="primary" class="btn fx-btn" @click="muitlSet">批量设置</el-button>
		</div>
		<el-dialog
			title="批量修改方式数值"
			:visible.sync="dialogVisible"
			class="dialog-title"
			width="450px"
			:close-on-click-modal="false">
			<div>
				<div class="dialog-percontent">
					<span style="flex-shrink:0">方式数值:</span>
					<el-select v-model="methodValue" class="per-select" size='small' @change="methodChange">
						<el-option :value="2" label="固定金额"></el-option>
						<el-option :value="1" label="百分比"></el-option>
					</el-select>
					<div class="per-money">
						<span class="per-tag">{{methodValue === 2 ? '￥' : '%'}}</span>
						<el-input class="per-input" v-model="percentValue" @input="percentInput" size="small">
					</el-input>
					</div>
				</div>
				<div style="text-align:center">
					<el-button class="btn" size="small" type="primary" @click="close">取消</el-button>
					<el-button class="btn" size="small" type="primary" @click="multiSave">保存</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'search',
	components: {
		// Print
	},
	props: {
		ids: {
			type: Array,
			default: () => []
		},
		tableData: {
			type: Array
		},
		customList: {
			type: Array,
			default: () => []
		},
		lineList: {
			type: Array,
			default: () => []
		},
		AuthorityList: {
			type: Object
		},
		needauditingflag: Boolean,
		bigcategoryview: Number,
		options: {
			type: Array,
			default: () => []
		},
		customerOptions: {
			type: Array,
			default: () => []
		}
	},
	watch: {
		bigcategoryview: {
			handler (val) {
				if (this.bigcategoryview === 1) {
					this.getSmalCategory()
				}
			},
			immediate: true
		}
	},
	data () {
		return {
			collapse: true,
			dialogVisible: false,
			methodValue: 2,
			percentValue: '',
			shopCategoryBigId: '0',
			shopCategorySmallId: '0',
			bc: [],
			sc: [],
			disabledflag: -1,
			staff: [],
			customer: [],
			product: '',
			spec: '',
			plantype: -1,
			planway: -1,
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		if (window.sessionStorage.getItem('percentSelect') && !this.filterFlag) {
			let data = JSON.parse(window.sessionStorage.getItem('percentSelect'))
			this.shopCategoryBigId = data.shopCategoryBigId
			this.shopCategorySmallId = data.shopCategorySmallId
			this.disabledflag = data.disabledflag
			this.staff = data.staff
			this.customer = data.customer
			this.product = data.product
			this.spec = data.spec
			this.plantype = data.plantype
			this.planway = data.planway
		}
		this.getBigCategory()
	},
	methods: {
		percentInput () {
			this.percentValue = this.percentValue.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			if (this.methodValue === 1) {
				if (+this.percentValue >= 1000) {
					this.percentValue = this.percentValue.substring(0, 3)
				} else {
					this.percentValue = this.percentValue.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				}
			} else {
				if (+this.percentValue >= 10000) {
					this.percentValue = this.percentValue.substring(0, 4)
				} else {
					this.percentValue = this.percentValue.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				}
			}
		},
		methodChange () {
			this.percentValue = ''
		},
		muitlSet () {
			if (this.ids.length === 0) {
				this.$message.warning('未勾选需要处理的数据，请勾选')
				return false
			}
			this.dialogVisible = true
		},
		multiSave () {
			if (!this.percentValue) {
				this.$message.error('提成方式不可为空！')
				return false
			}
			let params = {
				commissionType: this.methodValue,
				commissionValue: this.percentValue,
				commissionPlanIds: this.ids.join(',')
			}
			let planname = []
			this.tableData.forEach(e => {
				if (this.ids.indexOf(e.planid) !== -1) {
					planname.push(e.planname)
				}
			})
			let text = `方案名称【${planname.join(',')}】批量修改方案数值为【${this.methodValue === 2 ? '固定金额:￥' : '百分比:'}${this.percentValue}${this.methodValue === 2 ? '' : '%'}】`
			let changeData = {
				pre: { multiData: {} },
				cur: { multiData: { text: text } }
			}
			let logger = this.$fxLogger.createInfo('results.scheme-setting.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/saveBatchType`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.methodValue = 2
					this.percentValue = ''
					this.dialogVisible = false
					this.$message.success('成功处理' + this.ids.length + '条数据')
					this.$emit('modifySuc')
				} else {
					this.$message.error('处理失败，请稍后重试！')
				}
			})
		},
		close () {
			this.dialogVisible = false
		},
		goDetail () {
			window.sessionStorage.removeItem('percentageId')
			this.$router.push(`/main/percentageDetail`)
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.shopCategoryBigId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		bcChange (value) {
			this.shopCategorySmallId = '0'
			this.shopCategoryBigId = '' + value
			this.getSmalCategory()
		},
		search () {
			this.$emit('handleSearch', { shopCategoryBigId: this.shopCategoryBigId, shopCategorySmallId: this.shopCategorySmallId, disabledflag: this.disabledflag, staff: this.staff, customer: this.customer, product: this.product, spec: this.spec, plantype: this.plantype, planway: this.planway })
		},
		clear () {
			this.shopCategoryBigId = '0'
			this.shopCategorySmallId = '0'
			this.disabledflag = -1
			this.staff = []
			this.customer = []
			this.product = ''
			this.spec = ''
			this.plantype = -1
			this.planway = -1
			this.search()
		}
	}
}
</script>

<style lang="stylus" scoped>
.percent-search {
	display: flex;
	justify-content: space-between;
	width :100%;
	line-height :50px;
	margin-top: 10px;
}
.percent-search-btn {
	width: 200px;
	flex-shrink: 0
}
.filters-box-row {
	display: flex;
	flex-wrap: wrap;
	box-sizing: border-box
	overflow: hidden;
	text-align: left
	.input-box>span {
		display: inline-block;
		width: 80px;
		text-align: right;
	}
	&.filters-box-row3 {
		padding-top: 5px;
		// border-bottom: 1px solid #dce1fe;
		height: 50px
	}
	.filters-container {
		margin-right: 5px
		.filter-input {
			width: 160px
		}
	}
}
</style>
<style lang="stylus">
	.export-btn {
		span {
			display: flex;
			align-items: center
			div {
				width: 14px;
				height: 14px;
				margin-right: 5px;
				background-image: url('~images/icon/export-icon.png')
			}
		}
		&:hover {
			div {
				background-image: url('~images/icon/export-white-icon.png')
			}
		}
	}
	.dialog-percontent {
		display: flex
		align-items: center;
		margin: 20px 0 30px
		.per-select {
			width: 135px;
			margin: 0 10px
		}
		.per-money {
			position: relative
			.per-tag {
				position: absolute
				left: 1px
				top: 1px
				bottom: 1px;
				width: 40px;
				z-index: 9;
				display: flex;
				border-top-left-radius: 4px;
				border-bottom-left-radius: 4px;
				align-items: center;
				justify-content: center;
				background-color: #eee;
			}
			.per-input {
				width: 150px
				input {
					text-indent: 35px
				}
			}
		}
	}
	.input-tel input{
		-webkit-appearance: none;
		-webkit-box-sizing: content-box;
		font-family: inherit;
		font-size: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
</style>
